import React, { useEffect, useState, useRef } from "react";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { YEARS } from "../../utils/constantData";
import { getActiveUsers } from ".";
import { getGraphData } from "../../utils/graphManager";
import { PDFGenerator } from "../common/PdfGenerator";
import { ExportExcel } from "../common/ExcelGenerator";
import { ExportCSV } from "../common/CsvGenerator";
import { barChartOptions } from "../../utils/chartTheme";
import { buildDateRangeParams } from "../common/DateRangeFilter";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const labels = YEARS;



function getData(data) {
  return {
    labels,
    data: data,
    datasets: [
      {
        label: "Monthly active users",
        data: data,
        backgroundColor: "rgba(95, 142, 230, 0.78)",
        borderRadius: 10,
        maxBarThickness: 34,
      },
    ],
  };
}

export default function UserTimeSpendComponent({ dateFilter, onActiveUsersChange }) {
  const [data, setData] = useState({});
  const [dataPdf, setDataPdf] = useState([]);

  const chartRef = useRef(null);

  function getCount(data) {
    const activeUsersById = new Map();
    return Object.keys(data).map((key) => {
      const count = data[key]?.count || 0;
      const dataP = data[key].users;
      (dataP || []).forEach((user) => {
        if (user?.id) activeUsersById.set(user.id, user);
      });
      setDataPdf((prevData) => {
        const isDuplicate = prevData.some((item) => item.key === key);
        if (!isDuplicate) {
          return [...prevData, { data: dataP, key: key }];
        }
        return prevData;
      });
      if (typeof onActiveUsersChange === "function") {
        onActiveUsersChange(Array.from(activeUsersById.values()));
      }
      return [0, count];
    });
  }

  useEffect(() => {
    setDataPdf([])
    async function fetchData() {
      try {
        const response = await getActiveUsers(buildDateRangeParams(dateFilter));

        const responseData = response.data;
        setData(getCount(responseData?.data || {}));
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();
  }, [dateFilter]);

  

  return (
    <div className="chart-panel">
      <div className="chart-panel__header">
        <div>
          <span className="chart-panel__eyebrow">Engagement</span>
          <h2 className="chart-panel__title">Monthly active users</h2>
          <p className="chart-panel__description">
            See how many users are returning and staying active on the platform each month.
          </p>
        </div>
      </div>
      <div className="chart-canvas">
        <Bar
          ref={(ref) => {
            chartRef.current = ref;
          }}
          options={barChartOptions}
          data={getData(getGraphData(data))}
        />
      </div>
      <div className="chart-actions">
        <ExportExcel fileName="Monthly Active user" excelData={dataPdf} />
        <ExportCSV fileName="Monthly Active user" csvData={dataPdf}/>
        <PDFGenerator data={dataPdf} name="Monthly Active user"/>
      </div>
    </div>
  );
}
